import Card from '../../components/card/card.vue';

export default {
  name: 'About',
  data() {
    return {
      education: [
        {
          title: 'Computer Science, MS',
          subtitle: 'Western Washington University',
          dateText: 'September 2018 - June 2020',
          content: 'Research Interests: High-Level Programming Language Design, Compiler Theory and Design'
        },
        {
          title: 'Computer Science, BS',
          subtitle: 'Western Washington University',
          dateText: 'September 2014 - June 2018',
        }
      ],
      work: [
        {
          title: 'Software Development Engineer',
          subtitle: 'Advanced Micro Devices',
          dateText: 'July 2020 - Present',
          content: 'Analyze and optimize developer toolchains for AMD hardware, including compilers and runtime libraries.',
        },
        {
          title: 'Teaching Assistant/Instructor',
          subtitle: 'Computer Science Department, Western Washington University',
          dateText: 'March 2019 - June 2020',
          content: 'Instructed lab sessions and assisted Computer Science faculty with grading assignments and exams. Designed and taught introductory C++ course of 70 students in Spring 2020.',
        },
        {
          title: 'Software Engineer',
          subtitle: 'Restek, Western Washington University',
          dateText: 'May 2017 - September 2019',
          content: 'Designed, developed, and maintained web applications to support business operations for University Residences.',
        },
        {
          title: 'Help Desk Consultant',
          subtitle: 'ATUS, Western Washington University',
          dateText: 'March 2015 - May 2017',
          content: 'Provided technical support to faculty, staff, and students via phone, email, and in-person correspondence.',
        },
      ],
      volunteer: [
        {
          title: 'Teaching Assistant',
          subtitle: 'TEALS',
          dateText: 'September 2018 - June 2019',
          content: 'Aided in classroom instruction and labs for Introduction to Computer Science curriculum.'
        }
      ],
    };
  },
  components: {
    Card,
  },
};
